import React, { Fragment } from 'react'
import ContentLoader from 'react-content-loader'
import { memo } from 'react'

const OrderConfirmSkeleton = (props) => {
    return (
        <Fragment>

            {(() => {
                if (window.innerWidth >= 750)  // web
                    return <section className="check-out">
                        <div className="check-out-width">
                            <div className="checkout-header">

                                <ContentLoader className="checkout-header-skeleton"
                                    height={25}
                                    width={'100%'}
                                    speed={2}
                                    backgroundColor="#f3f3f3"
                                    foregroundColor="#ecebeb"
                                    {...props}
                                >
                                    <rect x="0%" y="0%" rx="0" ry="0" width="35%" height="30" /> {/*logo */}
                                    <rect x="60%" y="0%" rx="0" ry="0" width="35%" height="30" /> {/*number */}

                                </ContentLoader>

                            </div>
                           
{/*Product details*/}
                            <div className="booking-place-wrapper">
                                <div className="booking-place" id="scroll">
                                    <figure>
                                        <div className="booking-image">
                                            <ContentLoader className="form checkout-productdetail-skeleton"
                                                height={'100%'}
                                                width={'100%'}
                                                speed={2}
                                                backgroundColor="#f3f3f3"
                                                foregroundColor="#ecebeb"
                                                {...props}
                                            >
                                                <rect x="0.5%" y="0%" rx="0" ry="0" width="100%" height={'100%'} />
                                            </ContentLoader>
                                        </div>
                                    </figure>
                                    <figcaption>
                                        <div className="booked-place">
                                            <ContentLoader className="form checkout-productdetail-title-skeleton"
                                                height={'100%'}
                                                width={'100%'}
                                                speed={2}
                                                backgroundColor="#f3f3f3"
                                                foregroundColor="#ecebeb"
                                                {...props}
                                            >
                                                <rect x="5%" y="35%" rx="0" ry="0" width="90%" height={'10%'} />
                                                <rect x="5%" y="55%" rx="0" ry="0" width="90%" height={'10%'} />

                                                <rect x="5%" y="80%" rx="0" ry="0" width="40%" height={'30%'} />
                                                <rect x="55%" y="80%" rx="0" ry="0" width="40%" height={'30%'} />


                                            </ContentLoader>
                                        </div>

                                    </figcaption>
                                </div>


                            </div>

                      
                            <div className="image-content-wrapper check-out-5">
                                <div className="image-content">
                                    <div className="image-col">
                                        <div className="image-wrapper">
                                            <ContentLoader className="img-fluid checkout-image-desc-skeleton"
                                                height={'100%'}
                                                width={'100%'}
                                                speed={2}
                                                backgroundColor="#f3f3f3"
                                                foregroundColor="#ecebeb"
                                                {...props}
                                            >
                                                <rect x="0%" y="5%" rx="0" ry="0" width="100%" height={'100%'} />

                                            </ContentLoader>
                                        </div>

                                    </div>
                                    <div className="text-col">
                                        <ContentLoader className="txt checkout-desc-skeleton"
                                            height={'100%'}
                                            width={'100%'}
                                            speed={2}
                                            backgroundColor="#f3f3f3"
                                            foregroundColor="#ecebeb"
                                            {...props}
                                        >
                                            <rect x="0%" y="5%" rx="0" ry="0" width="99%" height={'10%'} />
                                            <rect x="0%" y="21%" rx="0" ry="0" width="85%" height={'10%'} />
                                            <rect x="0%" y="37%" rx="0" ry="0" width="95%" height={'10%'} />
                                            <rect x="0%" y="53%" rx="0" ry="0" width="99%" height={'10%'} />
                                            <rect x="0%" y="67%" rx="0" ry="0" width="99%" height={'10%'} />
                                        </ContentLoader>
                                    </div>

                                </div>
                            </div>
                            {/*Box */}
                            <div className="box-form-wrapper">
                                <div className="box-out-form">
                                    <div className="box-form-content" style={{ height: 200 }}>
                                        <ContentLoader className="form checkout-desc-skeleton"
                                            height={'100%'}
                                            width={'100%'}
                                            speed={2}
                                            backgroundColor="#f3f3f3"
                                            foregroundColor="#ecebeb"
                                            {...props}
                                        >
                                            <rect x="5%" y="5%" rx="0" ry="0" width="75%" height={'22%'} />
                                            <rect x="5%" y="35%" rx="0" ry="0" width="100%" height={'6%'} />
                                            <rect x="5%" y="45%" rx="0" ry="0" width="90%" height={'6%'} />
                                            <rect x="5%" y="55%" rx="0" ry="0" width="80%" height={'6%'} />
                                            <rect x="5%" y="80%" rx="0" ry="0" width="40%" height={'22%'} />
                                        </ContentLoader>
                                    </div>
                                </div>
                            </div>
                            <div className="two-col-box-wrapper"><div className="col-box-wrapper">
                                <div className="col-box">
                                    <ContentLoader className="form checkout-desc-skeleton"
                                        height={'100%'}
                                        width={'100%'}
                                        speed={2}
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                        {...props}
                                    >
                                        <rect x="5%" y="35%" rx="0" ry="0" width="80%" height={'10%'} />
                                        <rect x="5%" y="20%" rx="0" ry="0" width="80%" height={'10%'} />

                                        {/* <rect x="5%" y="17%" rx="0" ry="0" width="80%" height={'10%'} />
             <rect x="5%" y="3.5%" rx="0" ry="0" width="80%" height={'10%'} /> */}
                                    </ContentLoader>
                                </div>
                                <div className="col-box">
                                    <ContentLoader className="form checkout-desc-skeleton"
                                        height={'100%'}
                                        width={'100%'}
                                        speed={2}
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                        {...props}
                                    >
                                        <rect x="5%" y="17%" rx="0" ry="0" width="100%" height={'30%'} />
                                    </ContentLoader>
                                </div>
                            </div>
                            </div>
                        </div>
                    </section>
                else if (window.innerWidth < 750)  // mobile
                    return <section className="check-out">
                        <div className="check-out-width">
                            <div className="checkout-header">

                                <ContentLoader className="checkout-header-skeleton"
                                    height={100}
                                    width={'100%'}
                                    speed={2}
                                    backgroundColor="#f3f3f3"
                                    foregroundColor="#ecebeb"
                                    {...props}
                                >
                                    <rect x="22%" y="0%" rx="0" ry="0" width="48%" height="30" /> {/*logo */}
                                    <rect x="10%" y="50%" rx="0" ry="0" width="75%" height="25" /> {/*number */}

                                </ContentLoader>

                            </div>
                          

                            <div className="booking-place-wrapper">
                                <div className="drop-out-details skeleton" style={{height:70}}>
                                  
                                </div>
                            </div>

                            <div className="image-content-wrapper">
                                <div className="image-content">
                                    <div className="image-col">
                                        <div className="image-wrapper">
                                            <ContentLoader className="img-fluid checkout-image-desc-skeleton"
                                                height={'100%'}
                                                width={'100%'}
                                                speed={2}
                                                backgroundColor="#f3f3f3"
                                                foregroundColor="#ecebeb"
                                                {...props}
                                            >
                                                <rect x="25%" y="0%" rx="0" ry="0" width="50%" height={'100%'} />

                                            </ContentLoader>
                                        </div>

                                    </div>
                                    <div className="text-col">
                                        <ContentLoader className="txt checkout-desc-skeleton"
                                            height={'100%'}
                                            width={'100%'}
                                            speed={2}
                                            backgroundColor="#f3f3f3"
                                            foregroundColor="#ecebeb"
                                            {...props}
                                        >
                                            <rect x="15%" y="0%" rx="0" ry="0" width="75%" height={'15%'} />

                                            <rect x="0%" y="20%" rx="0" ry="0" width="100%" height={'8%'} />
                                            <rect x="9%" y="30%" rx="0" ry="0" width="85%" height={'8%'} />
                                            <rect x="18%" y="40%" rx="0" ry="0" width="60%" height={'8%'} />

                                            <rect x="0%" y="60%" rx="0" ry="0" width="100%" height={'8%'} />
                                            <rect x="0%" y="70%" rx="0" ry="0" width="100%" height={'8%'} />
                                            <rect x="0%" y="80%" rx="0" ry="0" width="100%" height={'8%'} />
                                            <rect x="0%" y="100%" rx="0" ry="0" width="100%" height={'8%'} />
                                            {/* <rect x="0%" y="32%" rx="0" ry="0" width="95%" height={'10%'} />
                                            <rect x="0%" y="48%" rx="0" ry="0" width="99%" height={'10%'} />
                                            <rect x="0%" y="62%" rx="0" ry="0" width="99%" height={'10%'} /> */}
                                        </ContentLoader>
                                    </div>

                                </div>
                            </div>


                        </div>
                    </section>
            })()}

        </Fragment>
    )
}



export default memo(OrderConfirmSkeleton)

